import axios from './axiosConfig';
import { API_URL } from '../config';


export interface PaginationRequest {
    page: number;
    size: number;
    sort_by: string;
    sort_order: 'ASC' | 'DESC';
}

export interface ChatFilterRequest {
    campaign_id?: number;
    user_id?: number;
    question?: string;
}

export interface ChatContextResponse {
    id: number;
    chat_id: number;
    question: string;
    question_version: string;
    score: number | null;
    created_at: string;
}

export interface ChatHistoryResponse {
    id: number;
    question: string;
    answer: string;
    campaign_id: number;
    token_usage: number;
    user_id: number;
    created_at: string;
    updated_at: string;
    contexts: ChatContextResponse[];
}
export interface ChatListResponse {
    total: number;
    page: number;
    size: number;
    items: ChatHistoryResponse[];
}

export interface ChatResponse {
    answer: string;
}

export const ChatService = {
    getAnswer: async (question: string, campaign_id: number): Promise<ChatResponse> => {
        try {
            const response = await axios.post(`${API_URL}/v1/chat`, { question, campaign_id });
            return response.data;
        } catch (error) {
            console.error('Error fetching answer:', error);
            throw error;
        }
    },
    getChats: async (pagination: PaginationRequest, filters: ChatFilterRequest): Promise<ChatListResponse> => {
        try {
            const response = await axios.post(`${API_URL}/v1/chats`, { pagination, filters });
            console.log(response.data)
            return response.data;
        } catch (error) {
            console.error('Error fetching chats:', error);
            throw error;
        }
    }
};


